import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    translate,
    check_interface,

} from '../../Utils';
import { api_crud_base, data_interface, api_list_route, endpoints, api_crud_route } from './Config';
import "../../assets/dataTable.css";
import UseSidebar from '../../UseSidebar';
import { getTokenInfo } from '../../UseToken';
import Hosts from '../../Hosts';
import { object_type } from './Config';
import ReactQuill from 'react-quill';
import { language } from "./Language";
import { color } from "../WEBContent/Color";
import { icon } from '../WEBContent/Icon';

export default function View(props) {

    // const [dados, set_dados] = useState(data_interface);

    const [, set_dados] = useState(null)
    const dados = useRef(null)
    //console.log('REVIEWERS', dados.info.reviewers[0].name)

    const [isloading, setLoading] = useState(true);
    const [isRedirect, /*setRedirect*/] = useState(false);

    const articles = useRef([]);
    const reviewers = useRef([]);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    const [tarefaId, setTarefaId] = useState('');
    const [nomeTarefa, setNomeTarefa] = useState('');
    const [selectedPrioridade, setSelectedPrioridade] = useState('')
    const [selectedEstado, setSelectedEstado] = useState('')
    const [selectedDataInicio, setSelectedDataInicio] = useState('')
    const [selectedDataLimite, setSelectedDataLimite] = useState('')
    const [refresh, setRefresh] = useState(0)

    //const [refresh, setRefresh] = useState(0);    
    const [colaboradores, setColaboradores] = useState([]);
    const [nomeResponsaveis, setResponsaveisNome] = useState('')
    const [nomeMonitor, setNomeMonitor] = useState('')
    const [userId, setUserId] = useState(null);
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState(null);
    const [nextId, setNextId] = useState(1);
    const [confirmar, setConfirmar] = useState(null)
    const [cancelClicked, setCancelClicked] = useState(false);
    const [submeter, setSubmeter] = useState(null)
    const [validada, setValidada] = useState(null)

    //Departamento
    const [departamentos, setDepartamentos] = useState([]);
    const [selectedDepartamento, setSelectedDepartamento] = useState('');
    const [departamentoid, setSelectedDepartamentoId] = useState(dados.current?.info?.departamentoid || null);

    // Responsavel   
    const [allResponsaveis, setAllResponsaveis] = useState([]);
    const [responsaveisPorDepartamento, setResponsaveisPorDepartamento] = useState({});
    const [descricao, setDescricao] = useState("");
    const [saving, setSaving] = useState(false);

    const [data, setData] = useState([]);
    const permissions = useRef(null);
    const { pathname } = useLocation()
    const [document_state_list, set_document_state_list] = useState([])

    const solucaoText = useRef(null)
    const saveSolucaoText = (value) => {
        set_dados(solucaoText.current = value);
    }

    const get_info = async () => {
        //await reqGET(api_list_route(getTokenInfo().companycode))
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    const styles = {
        container: {
            maxWidth: "800px",
            margin: "20px auto",
            padding: "20px",
            background: "#f8f9fa",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        },
        header: {
            background: "white",
            padding: "15px",
            borderRadius: "8px",
            textAlign: "center",
            fontSize: "1.5em",
            fontWeight: "bold",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            marginBottom: "20px",
        },
        section: {
            background: "white",
            padding: "20px",
            borderRadius: "8px",
            marginBottom: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        },
        sectionTitle: {
            marginBottom: "10px",
            fontSize: "1.2em",
            fontWeight: "bold",
        },
        grid: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "15px",
            paddingTop: "10px",
        },
        gridItem: {
            background: color.corCinza.hexa2,
            padding: "10px",
            borderRadius: "5px",
        },
        gridLabel: {
            fontWeight: "bold",
            color: color.cor3.rgb,
        },
        footer: {
            textAlign: "right",
            fontSize: "1em",
            fontWeight: "bold",
            padding: "15px",
        },
    };

    const calculateDeadline = (task, language, lang) => {
        if (!task || !task.info) {
            return { text: "-", style: { color: color.corCinza.hexa } };
        }

        const hoje = new Date();
        //const inicio = new Date(task.info.data_inicio);
        const fim = new Date(task.info.data_limite);
        const conclusao = task.info.dataConclusao ? new Date(task.info.dataConclusao) : null;

        const estado = task.info.estado?.labelPt || task.info.estado?.labelEn || "";

        // 1. Concluído e validado → Verde
        if (
            ((estado === "Concluído" || estado === "Completed") && task.info.validar === true)
        ) {
            return {
                text: estado,
                style: { fontWeight: "600", color: color.corVerde.rgb }
            };
        }

        // 2. Concluído antes da data limite → Verde
        if (conclusao && conclusao <= fim) {
            return {
                text: language[lang].concluido_antes_prazo || "Concluído no prazo",
                style: { fontWeight: "500", color: color.corVerde.rgb }
            };
        }

        // 3. Cancelado → Vermelho
        if (estado === "Cancelado" || estado === "Canceled") {
            return {
                text: estado,
                style: { fontWeight: "600", color: color.corVermelha.rgb }
            };
        }

        // Calcular diferença de dias
        const diferencaDias = Math.ceil((fim - hoje) / (1000 * 60 * 60 * 24));
        let prazoTexto = "";
        let cor = color.corCinza.hexa; // cor padrão (cinza)

        // 4. Atrasado → Vermelho
        if (hoje > fim && !conclusao) {
            const diasAtraso = Math.ceil((hoje - fim) / (1000 * 60 * 60 * 24));
            prazoTexto = `${language[lang].atrasado} ${diasAtraso} ${language[lang].dia}${diasAtraso !== 1 ? "s" : ""}`;
            cor = color.corVermelha.rgb;
        }
        // 5. Falta menos de 1 dia → Laranja
        else if (diferencaDias === 0) {
            prazoTexto = language[lang].menos_1dia;
            cor = color.corLaranja.rgb;
        }
        // 6. Dentro de 7 dias → Laranja
        else if (diferencaDias <= 7) {
            prazoTexto = `${diferencaDias} ${language[lang].dia}${diferencaDias !== 1 ? "s" : ""}`;
            cor = color.corLaranja.rgb;
        }
        // 7. Ainda no prazo (>7 dias) → Cinza
        else {
            prazoTexto = `${diferencaDias} ${language[lang].dia}${diferencaDias !== 1 ? "s" : ""}`;
            cor = color.corCinza.hexa;
        }

        return {
            text: prazoTexto,
            style: { color: cor, fontWeight: "500" }
        };
    };

    const getMonitorNome = (monitorArray) => {
        if (!Array.isArray(monitorArray) || monitorArray.length === 0) return 'Carregando...';
        const monitorLabels = monitorArray.map(monitor => monitor.label);
        return monitorLabels.join(', ');
    };

    const getResponsaveisNome = (responsaveisArray) => {
        if (!Array.isArray(responsaveisArray) || responsaveisArray.length === 0) return 'Nenhum responsável';
        const responsaveisLabels = responsaveisArray.map(responsavel => responsavel.label);
        return responsaveisLabels.join(', ');
    };

    const getEstadoStyle = (estado, lang) => {
        const estadoLabel = lang === 'en' ? estado.labelEn : estado.labelPt;

        switch (estadoLabel) {
            case 'Concluído':
            case 'Completed':
                return { color: color.corVerde.rgb, fontWeight: '600' }; // Verde
            case 'Em Progresso':
            case 'In Progress':
                return { color: color.corNormal.rgb, fontWeight: '600' }; // Azul
            case 'Em Execução':
            case 'In execution':
                return { color: color.corUrgente.rgb, fontWeight: '600' }; // Laranja
            case 'Pendente':
            case 'Pending':
                return { color: color.corCritica.rgb, fontWeight: '600' }; // Vermelho
            case 'A Iniciar':
            case 'To Start':
                return { color: color.corAmarela.rgb3, fontWeight: '600' }; // Amarelo
            case 'Em Revisão':
            case 'Under Review':
                return { color: color.corRoxa.rgb, fontWeight: '600' }; // Roxo
            case 'Cancelado':
            case 'Canceled':
                return { color: color.cor4.rgb, fontWeight: '600' }; // Cinza
            default:
                return { color: color.cor4.rgb, fontWeight: '600' }; // Cinza Claro
        }
    };

    useEffect(() => {
        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);
        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {
                if (data.user_info.user_info) {

                } else {

                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                }

            } else {
                console.log('User info nÃ£o encontrado no localStorage');
            }
        } else {
            console.log('Dados nÃ£o encontrados no localStorage');
        }
    }, []);

    const fetchInfo = async (id_search) => {
        let list_route = api_list_route(getTokenInfo().companycode);

        return await reqGET(`${list_route}/${id_search}`)
            .then(res => {
                const task = res.data[0];
                console.log('Tarefa', task);
                const { prioridade, data_inicio, data_limite, estado } = task.info;

                setTarefaId(task.id);
                setNomeTarefa(task.info.name);
                setSelectedPrioridade(prioridade);
                setSelectedEstado(estado);
                setSelectedDataInicio(data_inicio);
                setSelectedDataLimite(data_limite);

                setNomeMonitor(getMonitorNome(task.info.monitor));
                setResponsaveisNome(getResponsaveisNome(task.info.responsaveis));

                set_dados(dados.current = task);

                setLoading(false);
            })
            .catch(() => 404);
    };

    useEffect(() => {
        if (dados?.current?.info?.departamentoid) {
            setSelectedDepartamento(dados.current.info.departamentoid);
        }

        if (dados?.current?.info?.solucao?.solucao) {
            set_dados(solucaoText.current = dados.current.info.solucao.solucao);
            setRefresh(prev => prev + 1);

        } else {
            set_dados(solucaoText.current = "");
            setRefresh(prev => prev + 1);
        }

    }, [dados.current]);

    useEffect(() => {
        if (departamentoid) {
            fetch_departamentos(departamentoid || dados.current?.info.departamentoid);
        }
    }, [departamentoid]);

    const fetch_departamentos = async () => {
        try {
            const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
            const departamentoOptions = res.data.map(departamento => ({
                value: departamento.id,
                label: departamento.info.name
            }));
            console.log("Departamentos:", departamentoOptions);
            setDepartamentos(departamentoOptions);
        } catch (error) {
            console.error("Erro ao buscar os departamentos:", error);
        }
    };

    useEffect(() => {
        const fetch_colaboradores = async () => {
            try {
                const res = await reqGET(Hosts.SIMCore_API + '/entities/list/' + getTokenInfo().companycode + '/Colaborador');

                const colaboradoresOptions = res.data.map(colaborador => ({
                    label: colaborador.name,
                    value: colaborador.id,
                    departamento: colaborador.departamento,
                    email: colaborador.email
                }));

                setAllResponsaveis(colaboradoresOptions);
                console.log("Colaboradores:", colaboradoresOptions);
            } catch (error) {
                console.error("Erro ao buscar os colaboradores:", error);
            }
        };
        fetch_colaboradores();
    }, []);

    useEffect(() => {
        if (allResponsaveis.length > 0 && departamentos.length > 0) {
            const responsaveisMap = {};

            // Iterar sobre cada colaborador
            allResponsaveis.forEach(colaborador => {
                colaborador.departamento.forEach(depto => {
                    // Se o departamento já existir no mapa, adicionamos o colaborador
                    if (!responsaveisMap[depto.id]) {
                        responsaveisMap[depto.id] = [];
                    }
                    // Adicionar um objeto com o id e o nome do colaborador
                    responsaveisMap[depto.id].push({ label: colaborador.label, value: colaborador.value, email: colaborador.email });
                });
            });

            // Agora temos um objeto com o ID do departamento como chave e os responsáveis como valor
            setResponsaveisPorDepartamento(responsaveisMap);
            console.log("Responsáveis por departamento:", responsaveisMap);
        }
    }, [allResponsaveis, departamentos]);

    useEffect(() => {
        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt');
            set_language('pt');
            set_lang_id('1');
        } else {
            set_lang(localStorage.getItem('lang'));
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id);
                }
            });
        }

        fetchInfo(props.location.state.item['id']).then(async () => {
            const lista_revs = await get_reviewers();
            reviewers.current = lista_revs;

            const lista_arts = await get_articles(props.location.state.item['id']);
            articles.current = lista_arts;

        });

    }, [props]);

    const get_reviewers = async () => {
        let aReviewers = [];

        return await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Revisor`)
            .then(res => {
                //console.log(res.data)

                res.data.forEach(v => {
                    aReviewers.push({ label: v.name, label2: v.surname, value: v.id })
                });

                //set_reviewers(aReviewers)
                return aReviewers
                //console.log('REVIEWERS', aReviewers)
            })
            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    const get_articles = async (id) => {

        let aArticles = [];

        /* CHAMADA ARTIGOS */
        return await reqGET(`${api_crud_base}/tarefa/${getTokenInfo().companycode}`)
            .then(res => {
                //console.log(res.data)
                res.data.forEach(x => {
                    let aux = { id: x.id, title: x.info.title, cfp: x.info.id_cfp, reviewers: reviewers }

                    if (x.info.id_cfp === id) {
                        aArticles.push(aux);
                    }
                });
                return aArticles
            })

            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    // Function to handle export logic
    const handleExport = () => {
        // Example export logic: exporting task data as JSON
        const exportData = {
            id: dados.current.id,
            name: dados.current.info.name,
            companycode: dados.info.companycode,
            prioridade: dados.info.prioridade,
            data_inicio: dados.info.data_inicio,
            data_limite: dados.info.data_limite,
            estado: dados.info.estado,
            departamento: dados.info.departamento,
            nomeMonitor: nomeMonitor,
            description: dados.current.info.description,
            solucao: dados.current.info.solucao,
            colaboradores: colaboradores.map(responsavel => responsavel.label).join('\n')
        };

        const json = JSON.stringify(exportData, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        // Create a temporary link and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = `tarefa_${dados.id}_relatorio.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url); // Clean up URL
    };

    // Function to handle print logic
    const handlePrint = () => {
        const printContent = document.getElementById('printable').innerHTML;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent;
        window.print();

        document.body.innerHTML = originalContent;
    };

    const exportAllowed = true;
    const printAllowed = true;

    const handle_atualizar = async (event) => {
        const { name, value } = event.target;

        try {

            dados.current.info[name] = value;

            if (value !== null && value !== undefined && value !== '') {
                dados.current.info.confirmar = true;

                // Estado 1 → 3 (Em Progresso)
                if (dados.current.info.estado.value === 1 && dados.current.info.confirmar) {
                    dados.current.info.estado = {
                        value: 3,
                        labelPt: "Em Progresso",
                        labelEn: "In Progress"
                    };
                }

                // Estado 3 → 4 (Em Execução)
                else if (dados.current.info.estado.value === 3 && dados.current.info.solucao && Object.keys(dados.current.info.solucao).length > 0) {
                    dados.current.info.estado = {
                        value: 4,
                        labelPt: "Em Execução",
                        labelEn: "In Execution"
                    };
                    dados.current.info.submeter = true;
                }

                // Estado 4 → 5 (Em Revisão)
                else if (dados.current.info.estado.value === 4 && dados.current.info.submeter === true) {
                    dados.current.info.estado = {
                        value: 5,
                        labelPt: "Em Revisão",
                        labelEn: "Under Revision"
                    };
                    dados.current.info.validar = true;
                }

                // Estado 5 → 6 (Concluído)
                else if (dados.current.info.estado.value === 5 && dados.current.info.validar === true) {
                    dados.current.info.estado = {
                        value: 6,
                        labelPt: "Concluído",
                        labelEn: "Completed"
                    };
                    dados.current.info.dataConclusao = dados.current.info.solucao?.dataSubmissao ?? null;
                }

            } else {

                console.log('Cancelando tarefa ou limpando confirmação');

                dados.current.info.validar = false;
                // Estado 1 → 2 (Cancelado)
                if (dados.current.info.estado.value === 1) {
                    dados.current.info.estado = {
                        value: 2,
                        labelPt: "Cancelado",
                        labelEn: "Canceled"
                    };
                    dados.current.info.confirmar = false;
                }

                // Estado 5 → 4 (Não Validado)
                else if (dados.current.info.estado.value === 5 && dados.current.info.validar === false) {
                    dados.current.info.estado = {
                        value: 4,
                        labelPt: "Em Execução",
                        labelEn: "In Execution"
                    };
                    dados.current.info.submeter = true;
                    dados.current.info.validar = false;
                }
            }

            set_dados(dados.current);

            await reqPUT(api_crud_route, dados.current);
            setRefresh(prev => prev + 1);

        } catch (err) {
            console.error("Erro ao atualizar tarefa:", err);
        }
    };

    const handleSaveSolucao = async () => {
        try {
            setSaving(true);

            const updatedSolucao = {
                ...dados.current.info.solucao,
                solucao: solucaoText.current,
                dataAtual: new Date().toISOString(),
            };

            dados.current.info.solucao = updatedSolucao;
            await reqPUT(api_crud_route, dados.current);
            setRefresh((prev) => prev + 1);

        } catch (err) {
            console.error("Error saving solucao:", err);
        } finally {
            setSaving(false);
        }
    };

    console.log('Dados da tarefa:', dados.current);

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{language[lang].loading}</h2>
                    <p>{language[lang].loading}</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div style={styles.container}>
                    {/* Overview */}
                    <div style={styles.section}>
                        <h3 style={styles.sectionTitle}>{language[lang].tarefa} {language[lang].task_number}{dados.current.id} - {language[lang].relatorio}</h3>
                        <div style={styles.grid}>
                            <div style={styles.gridItem}><span style={styles.label}>{language[lang].titulo_tarefa}:</span> {dados.current.info.name}</div>
                            <div style={styles.gridItem}><span style={styles.label}>{language[lang].codigo_tarefa}:</span> {dados.current.info.companycode}</div>
                            <div style={styles.gridItem}><span style={styles.label}>{language[lang].data_inicio}:</span> {dados.current.info.data_inicio}</div>
                            <div style={styles.gridItem}><span style={styles.label}>{language[lang].data_limite}:</span> {dados.current.info.data_limite}</div>
                            <div style={styles.gridItem}><span style={styles.label}>{language[lang].tarefa_prioridade}:</span> {lang === "pt" ? dados.current.info.prioridade.labelPt : dados.current.info.prioridade.labelEn}</div>
                            <div style={styles.gridItem}>
                                <span style={styles.label}>{language[lang].tarefa_estado}: </span>
                                <span style={getEstadoStyle(dados.current.info.estado, lang)}>
                                    {lang === "pt" ? dados.current.info.estado.labelPt : dados.current.info.estado.labelEn}
                                </span>
                            </div>
                            {/*<div style={styles.gridItem}><span style={styles.label}>{language[lang].tarefa_estado}:</span> {lang === "pt" ? dados.current.info.estado.labelPt : dados.current.info.estado.labelEn}</div>*/}
                            <div style={styles.gridItem}><span style={styles.label}>{language[lang].tarefa_monitor}:</span> {nomeMonitor}</div>
                            <div style={styles.gridItem}>
                                <span style={styles.label}>{language[lang].tarefa_tempo_expiracao}: </span>
                                <span style={calculateDeadline(dados.current, language, lang).style}>
                                    {calculateDeadline(dados.current, language, lang).text}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Description */}
                    <div style={styles.section}>
                        <h3 style={styles.sectionTitle}>{language[lang].description}</h3>
                        <div dangerouslySetInnerHTML={{ __html: dados.current.info.description }} />
                    </div>

                    {/* Solution Section */}
                    {solucaoText.current != null && (
                        <div style={styles.section}>
                            <h3 style={styles.sectionTitle}>{language[lang].solucao}</h3>

                            <ReactQuill
                                value={solucaoText.current}
                                onChange={(e) => { saveSolucaoText(e); }}
                                theme="snow"
                            />

                            <div className="row mt-3">
                                <div className="col">
                                    {dados.current.info.solucao?.dataAtual && (
                                        <div>
                                            <span style={styles.label}>
                                                {language[lang].tarefa_data_solucao}:
                                            </span>{" "}
                                            {new Date(dados.current.info.solucao.dataAtual).toLocaleString()}
                                        </div>
                                    )}
                                </div>

                                <div className="col text-end">
                                    <button onClick={handleSaveSolucao} disabled={saving}>
                                        {saving ? (
                                            <i className="bi bi-arrow-repeat"></i>
                                        ) : (
                                            <i className={icon.save.className} style={icon.save.style}></i>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div>
                        {/* Confirmar */}
                        {dados.current.info.estado.value === 1 &&
                            dados.current?.info?.monitor[0]?.value === userId && (
                                <div className="container ms-3 mt-2">
                                    {/* Row do Label */}
                                    <div className="row">
                                        <div className="col">
                                            <label style={styles.label}>
                                                {language[lang].confirmar_tarefa}
                                            </label>
                                        </div>
                                    </div>

                                    {/* Row dos Botões */}
                                    <div className="row mt-2">
                                        <div className="col d-flex gap-2">
                                            {/* Botão Confirmar */}
                                            <button
                                                type="button"
                                                className={`btn btn-sm border-0 ${confirmar ? "btn-outline-success" : "btn-outline-primary"
                                                    }`}
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Confirmar tarefa?",
                                                        text: "Tens a certeza que queres confirmar esta tarefa?",
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Sim, confirmar",
                                                        cancelButtonText: "Não",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            const currentDateTime = new Date().toISOString();

                                                            handle_atualizar({
                                                                target: { name: "dataConfirmacao", value: currentDateTime },
                                                            });

                                                            setConfirmar(true);
                                                            setCancelClicked(false);

                                                            Swal.fire("Confirmada!", "A tarefa foi confirmada.", "success");
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="bi bi-check-circle-fill fs-4"></i>
                                            </button>

                                            {/* Botão Cancelar */}
                                            <button
                                                type="button"
                                                className={`btn btn-sm border-0 ${cancelClicked ? "btn-outline-danger" : "btn-outline-warning"
                                                    }`}
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Cancelar tarefa?",
                                                        text: "Tens a certeza que queres cancelar esta tarefa?",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Sim, cancelar",
                                                        cancelButtonText: "Não",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            handle_atualizar({
                                                                target: { name: "dataConfirmacao", value: "" },
                                                            });

                                                            setConfirmar(false);
                                                            setCancelClicked(true);

                                                            Swal.fire("Cancelada!", "A tarefa foi cancelada.", "error");
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="bi bi-x-circle-fill fs-4"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {/* Submeter */}
                        {dados.current.info.estado.value === 4 &&
                            dados.current.info.responsaveis[0].value === userId && (
                                <div className="container ms-3 mt-2">
                                    {/* Row do Label */}
                                    <div className="row">
                                        <div className="col">
                                            <label style={styles.label}>
                                                {language[lang].submeter_tarefa}
                                            </label>
                                        </div>
                                    </div>

                                    {/* Row dos Botões */}
                                    <div className="row mt-2">
                                        <div className="col d-flex gap-2">
                                            {/* Botão de Submeter */}
                                            <button
                                                type="button"
                                                className={`btn btn-sm border-0 ${submeter ? "btn-outline-success" : "btn-outline-primary"
                                                    }`}
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Submeter tarefa?",
                                                        text: "Tens a certeza que queres submeter esta tarefa?",
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Sim, submeter",
                                                        cancelButtonText: "Não",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            const currentDateTime = new Date().toISOString();

                                                            handle_atualizar({
                                                                target: { name: "dataSubmissao", value: currentDateTime },
                                                            });

                                                            setSubmeter(true);

                                                            Swal.fire("Submetida!", "A tarefa foi submetida.", "success");
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="bi bi-check-circle-fill fs-4"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {/* Validar */}
                        {dados.current.info.estado.value === 5 &&
                            dados.current.info.monitor[0].value === userId && (
                                <div className="container ms-3 mt-2">
                                    {/* Row do Label */}
                                    <div className="row">
                                        <div className="col">
                                            <label style={styles.label}>
                                                {language[lang].validar_tarefa}
                                            </label>
                                        </div>
                                    </div>

                                    {/* Row dos Botões */}
                                    <div className="row mt-2">
                                        <div className="col d-flex gap-2">
                                            {/* Botão de Validar */}
                                            <button
                                                type="button"
                                                className={`btn btn-sm border-0 ${validada ? "btn-outline-success" : "btn-outline-primary"
                                                    }`}
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Validar tarefa?",
                                                        text: "Queres validar esta tarefa?",
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Sim, validar",
                                                        cancelButtonText: "Não",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            const currentDateTime = new Date().toISOString();

                                                            setValidada(true);

                                                            handle_atualizar({
                                                                target: { name: "dataConclusao", value: currentDateTime },
                                                            });

                                                            Swal.fire("Validada!", "A tarefa foi validada.", "success");
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="bi bi-check-circle-fill fs-4"></i>
                                            </button>

                                            {/* Botão de Não Validar */}
                                            <button
                                                type="button"
                                                className="btn btn-sm border-0 btn-outline-danger"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Não validar tarefa?",
                                                        text: "Tens a certeza que queres rejeitar esta tarefa?",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Sim, rejeitar",
                                                        cancelButtonText: "Não",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {

                                                            setValidada(false);


                                                            handle_atualizar({
                                                                target: { name: "dataConclusao", value: "" },
                                                            });

                                                            Swal.fire("Rejeitada!", "A tarefa foi rejeitada.", "error");
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="bi bi-x-circle-fill fs-4"></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/* Textarea só aparece se não for validada */}
                                    {validada === false && (
                                        <div className="row mt-3">
                                            <div className="col">
                                                <label className="fw-bold">
                                                    {language[lang].detalhes}
                                                </label>
                                                <textarea
                                                    className="form-control mt-2"
                                                    rows="4"
                                                    value={descricao}
                                                    onChange={(e) => setDescricao(e.target.value)}
                                                    placeholder={language[lang].detalhes_placeholder}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                    </div>

                    {/* Responsible Users */}
                    <div style={styles.footer}>
                        <span style={styles.label}>{language[lang].tarefa_resp}</span> <p>{nomeResponsaveis}</p>
                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">

                                    {dados.current.info.validar === true && exportAllowed && (
                                        <button className="btn btn-export btn-outline-primary mr-2" onClick={handleExport}>
                                            <i className="bi bi-download"></i> {language[lang].exportar_relatorio}
                                        </button>
                                    )}

                                    {dados.current.info.validar === false && printAllowed && (
                                        <button className="btn btn-print btn-outline-secondary" onClick={handlePrint}>
                                            <i className="bi bi-printer"></i> {language[lang].imprimir_relatorio}
                                        </button>
                                    )}

                                    {(permissions.current !== null && permissions.current.create) && (
                                        <Link className="nav-link" to={{ state: { item: { id: tarefaId }, operation: 'edit' }, pathname: endpoints.regist }} replace>
                                            <i className={icon.pencil2.className} style={icon.pencil2.style}></i>
                                            <span> {language[lang].edit}</span>
                                        </Link>
                                    )}

                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <i className="bi bi-arrow-left"></i>
                                        <span> {language[lang].back}</span>
                                    </Link>

                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </main>
}